import { render, staticRenderFns } from "./Campanhas.vue?vue&type=template&id=5c466f78&scoped=true"
import script from "./Campanhas.vue?vue&type=script&lang=js"
export * from "./Campanhas.vue?vue&type=script&lang=js"
import style0 from "./Campanhas.vue?vue&type=style&index=0&id=5c466f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c466f78",
  null
  
)

export default component.exports